import { render, staticRenderFns } from "./CookiesNotificationBanner.vue?vue&type=template&id=3478c135&scoped=true&"
import script from "./CookiesNotificationBanner.vue?vue&type=script&lang=js&"
export * from "./CookiesNotificationBanner.vue?vue&type=script&lang=js&"
import style0 from "./CookiesNotificationBanner.vue?vue&type=style&index=0&id=3478c135&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3478c135",
  null
  
)

export default component.exports